/**
 * RollupCaption — 会議用の流れる字幕（1段分）
 * 確定した文を順に並べ、最後に翻訳途中の文を続ける。最大 lines 行に収まらないときは、
 * 古い文から「文ごと」消す（段がいつも文の頭から始まるように）。
 * 1文だけで lines 行を超えるときは、その文の古い行を上へ押し出す。
 */
import { useLayoutEffect, useRef } from 'react';
import type { OBSStyleMode } from '../types';

type Props = {
  finals: string[];
  interim: string;
  fontSize: number;
  lines: number;
  obsStyle: OBSStyleMode;
};

export default function RollupCaption({ finals, interim, fontSize, lines, obsStyle }: Props) {
  const dark = obsStyle === 'white-black';
  const lineHeight = 1.35;
  const pRef = useRef<HTMLParagraphElement>(null);
  const items = [...finals, interim].filter(Boolean);

  useLayoutEffect(() => {
    const p = pRef.current;
    if (!p) return;
    const spans = Array.from(p.children) as HTMLElement[];
    spans.forEach((s) => { s.style.display = ''; });
    const max = lines * lineHeight * fontSize + 2;
    for (let i = 0; i < spans.length - 1 && p.scrollHeight > max; i++) spans[i].style.display = 'none';
  });

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '0.4em 3%', boxSizing: 'border-box', fontSize }}>
      <div style={{ maxHeight: `${lines * lineHeight}em`, overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
        <p ref={pRef} style={{ margin: 0, lineHeight, fontWeight: 700, color: dark ? '#111' : '#fff', overflowWrap: 'anywhere', lineBreak: 'strict' }}>
          {items.length ? items.map((t, i) => <span key={finals.length - items.length + i}>{t}{i < items.length - 1 ? ' ' : ''}</span>) : ' '}
        </p>
      </div>
    </div>
  );
}
